module.exports = "mutation UpdateBannerSlotItem($data:BannerSlotItemInput!){updateBannerSlotItem(data:$data){success}}"